import { useState } from "react";
import Moment from "react-moment";
import { useEffect } from "react";
import InviteList from "./InviteList";
import SendInvitation from "./SendInvitation";
import { Form, Table } from "react-bootstrap";
import UseToggle from "../../../Hooks/UseToggle";
import { inviteServices } from "../../../APIServices/UserData/inviteServices";
import ToolBar from "../../CRMManagement/ToolBar";

const InvitationManagement = ({ organizationList, getOrganizations, currentUserData }) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [invitations, setInvitations] = useState([]);
  const [invitationData, setInvitationData] = useState("");
  const [invitationCount, setInvitationCount] = useState(0);
  const [invitationIds, setInvitationIds] = useState([]);

  const toggleSingle = (id) => {
    setInvitationIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const toggleAll = () => {
    if (invitationIds.length === invitationCount) {
      setInvitationIds([]);
    } else {
      setInvitationIds(invitations.map((c) => c._id));
    }
  };

  const isAllChecked =
    invitationCount > 0 && invitationIds.length === invitationCount;
  const isChecked = (id) => invitationIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(invitationCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, invitationCount);

  const getInvitationList = async () => {
    setLoader(true)
    let data = await inviteServices.getInvitation("all", search, pageNumber, itemsPerPage)
    setInvitations(data?.data || [])
    setInvitationCount(data?.count || 0)
    setLoader(false)
  }

  useEffect(() => {
    getInvitationList()
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <div className="w-100" style={{ height: "calc(100vh - 57px)" }}>
        <ToolBar
          sendNow
          toggles={toggles}
          search={search}
          setSearch={setSearch}
          checkedIds={invitationIds}
          setCheckedIds={setInvitationIds}
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          setSelected={setInvitationData}
          start={start}
          end={end}
          totalItems={invitationCount}
          page={pageNumber}
          setPage={setPageNumber}
          setPageSize={setItemsPerPage}
          pageSize={itemsPerPage}
          totalPages={totalPages}
          addField
          editField
        />

        <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
          <div className={`table-section overflow-auto bg-white ${showPreview ? "border-end" : ""}`} style={{ height: "calc(100vh - 50px)" }}>
            <Table hover className="contacts-table mb-0" style={{ verticalAlign: "middle" }}>
              <thead>
                <tr>
                  <th>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isAllChecked}
                          onChange={toggleAll}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>Email</div>
                    </div>
                  </th>
                  {!invitationData && (
                    <>
                      <th>Invited By</th>
                      <th>Invitation Date | Time</th>
                      <th>Accept / Reject Date | Time</th>
                      <th>Status</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {invitations.map((item) => (
                  <tr key={item._id} className={`contact-row ${invitationData?._id === item._id ? "active" : ""}`} onClick={() => { setInvitationData(item); setShowPreview(true); }}>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <div className="px-2">
                          <Form.Check
                            type="checkbox"
                            checked={isChecked(item._id)}
                            onChange={() => toggleSingle(item._id)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        <div>
                          <div className="fw-medium">{item.email}</div>
                          <small className="text-muted">{item.designation}</small>
                        </div>
                      </div>
                    </td>

                    {!invitationData && (
                      <>
                        <td>{item.invitedByName}</td>
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item?.invitationDate}
                          </Moment>
                        </td>
                        <td>
                          {item.acceptRejectDate ?
                            <Moment format="DD MMM YYYY | HH:mm" withTitle>
                              {item?.invitationDate}
                            </Moment>
                            : "_"
                          }
                        </td>
                        <td><span className={`text-capitalize badge ${item.status === "accepted" ? "bg-success" : item.status === "rejected" ? "bg-danger" : "bg-warning text-dark"}`}>{item.status}</span></td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className={`preview-section ${showPreview ? "open" : ""}`}>
            {invitationData && (
              <div className="overflow-auto" style={{ height: "calc(100vh - 50px)" }}>
                <div className="preview-scroll p-0">
                  <div className="preview-block">
                    <InviteList invitationId={invitationData?._id} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <SendInvitation
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Send Invitation`}
        getInvitationList={getInvitationList}
        organizationList={organizationList}
      />
    </>
  );
};

export default InvitationManagement;
